var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.requiredIf && _vm.show)?_c('div',[_c('CBadge',{staticClass:"ma-2",attrs:{"color":"danger","x-small":"","label":""}},[_vm._v("必須")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }